/* src/app/shared/common-ui/lib/search-input/search-input.component.less */
:host {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
:host .wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  border-bottom: 0.1rem solid var(--color-default-theme);
}
:host .wrapper.regular {
  min-width: 16rem;
}
:host .wrapper.regular input {
  height: 3.5rem;
  max-width: initial;
  padding: 0;
  padding-right: 6rem;
  background: transparent;
  border: 0;
}
:host .wrapper.regular input.empty {
  padding-right: 3rem;
}
:host .wrapper.regular .icon.search {
  position: absolute;
  right: 0;
  bottom: 0.5rem;
  height: 2.4rem;
  width: 2.4rem;
  background: var(--color-default-theme);
  cursor: pointer;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Search%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Search%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C5.5%20C20.2467051%2C5.5%2024.5%2C9.75329488%2024.5%2C15%20C24.5%2C17.0819334%2023.8302914%2C19.0074481%2022.6945516%2C20.5728665%20L28.7713898%2C26.6500695%20L26.6500695%2C28.7713898%20L20.5728665%2C22.6945516%20C19.0074481%2C23.8302914%2017.0819334%2C24.5%2015%2C24.5%20C9.75329488%2C24.5%205.5%2C20.2467051%205.5%2C15%20C5.5%2C9.75329488%209.75329488%2C5.5%2015%2C5.5%20Z%20M15%2C8.5%20C11.4101491%2C8.5%208.5%2C11.4101491%208.5%2C15%20C8.5%2C18.5898509%2011.4101491%2C21.5%2015%2C21.5%20C18.5898509%2C21.5%2021.5%2C18.5898509%2021.5%2C15%20C21.5%2C11.4101491%2018.5898509%2C8.5%2015%2C8.5%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%23005EB8%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center center;
  mask-size: 2.4rem 2.4rem;
}
:host .wrapper.regular .icon.clear {
  position: absolute;
  right: 3rem;
  bottom: 0.9rem;
  height: 1.8rem;
  width: 1.8rem;
  background: var(--color-default-text-help);
  cursor: pointer;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Clear%20%2F%20Filled%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Clear-%2F-Filled%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M18%2C2%20C26.8367059%2C2%2034%2C9.16329412%2034%2C18%20C34%2C26.8357647%2026.8367059%2C34%2018%2C34%20C9.16423529%2C34%202%2C26.8357647%202%2C18%20C2%2C9.16329412%209.16423529%2C2%2018%2C2%20Z%20M23.3033009%2C10.5753788%20L18%2C15.8786797%20L12.6966991%2C10.5753788%20L10.5753788%2C12.6966991%20L15.8779725%2C17.9992929%20L10.5753788%2C23.3033009%20L12.6966991%2C25.4246212%20L17.9992929%2C20.1206132%20L23.3033009%2C25.4246212%20L25.4246212%2C23.3033009%20L20.1213203%2C18%20L25.4246212%2C12.6966991%20L23.3033009%2C10.5753788%20Z%22%20id%3D%22Clear-Search%22%20fill%3D%22%23ACB4B9%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper.picker {
  justify-content: flex-end;
  height: 3.1rem;
  width: 2.4rem;
  max-width: 30rem;
  border-bottom: 0.1rem solid transparent;
}
:host .wrapper.picker input {
  height: 3.1rem;
  width: 0;
  max-width: initial;
  padding: 0;
  padding-right: 6rem;
  background: transparent;
  border: 0;
  border-bottom: 0.1rem solid var(--color-default-theme);
  opacity: 0;
  transition: all 0.5s ease-in-out;
}
:host .wrapper.picker input.empty {
  padding-right: 3rem;
}
:host .wrapper.picker .icon.search {
  position: absolute;
  right: 0;
  bottom: 0.2rem;
  height: 2.4rem;
  width: 2.4rem;
  background: var(--color-default-theme);
  cursor: pointer;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Search%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Search%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M15%2C5.5%20C20.2467051%2C5.5%2024.5%2C9.75329488%2024.5%2C15%20C24.5%2C17.0819334%2023.8302914%2C19.0074481%2022.6945516%2C20.5728665%20L28.7713898%2C26.6500695%20L26.6500695%2C28.7713898%20L20.5728665%2C22.6945516%20C19.0074481%2C23.8302914%2017.0819334%2C24.5%2015%2C24.5%20C9.75329488%2C24.5%205.5%2C20.2467051%205.5%2C15%20C5.5%2C9.75329488%209.75329488%2C5.5%2015%2C5.5%20Z%20M15%2C8.5%20C11.4101491%2C8.5%208.5%2C11.4101491%208.5%2C15%20C8.5%2C18.5898509%2011.4101491%2C21.5%2015%2C21.5%20C18.5898509%2C21.5%2021.5%2C18.5898509%2021.5%2C15%20C21.5%2C11.4101491%2018.5898509%2C8.5%2015%2C8.5%20Z%22%20id%3D%22Combined-Shape%22%20fill%3D%22%23005EB8%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center center;
  mask-size: 2.4rem 2.4rem;
}
:host .wrapper.picker .icon.clear {
  position: absolute;
  right: 3rem;
  bottom: 0.6rem;
  height: 1.8rem;
  width: 1.8rem;
  background: var(--color-default-text-help);
  cursor: pointer;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Clear%20%2F%20Filled%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Clear-%2F-Filled%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M18%2C2%20C26.8367059%2C2%2034%2C9.16329412%2034%2C18%20C34%2C26.8357647%2026.8367059%2C34%2018%2C34%20C9.16423529%2C34%202%2C26.8357647%202%2C18%20C2%2C9.16329412%209.16423529%2C2%2018%2C2%20Z%20M23.3033009%2C10.5753788%20L18%2C15.8786797%20L12.6966991%2C10.5753788%20L10.5753788%2C12.6966991%20L15.8779725%2C17.9992929%20L10.5753788%2C23.3033009%20L12.6966991%2C25.4246212%20L17.9992929%2C20.1206132%20L23.3033009%2C25.4246212%20L25.4246212%2C23.3033009%20L20.1213203%2C18%20L25.4246212%2C12.6966991%20L23.3033009%2C10.5753788%20Z%22%20id%3D%22Clear-Search%22%20fill%3D%22%23ACB4B9%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center center;
  mask-size: 1.8rem 1.8rem;
}
:host .wrapper.picker.expanded {
  width: 100%;
  max-width: 30rem;
}
:host .wrapper.picker.expanded input {
  width: 100%;
  opacity: 1;
}
/*# sourceMappingURL=search-input.component.css.map */
